import "./App.css";
import Calculator from "./components/Calculator";

function App() {
  return (
    <div>
      <Calculator />
    </div>
  );
}

export default App;
